import { Container, createStyles, Group, Overlay, SimpleGrid, Text, Title, useMantineTheme } from '@mantine/core';
import { useEffect, useState } from 'react';
import CategoryNavbar from '../../components/category-navbar';
import ProductCard, { ProductCardProp } from '../../components/product-card';
import ImageStorageService from '../../services/ImageStorageService';
import { TranslationService } from '../../services/TranslationService';
import { GetTranslated, TranslateField } from '../../types/translate-field';
import API from '../../apis/api';
import NavBar, { NavBarItem } from '../../components/navbar';
import { TranslateCategory } from '../../apis/response/GetCategoryResponse';
import DefaultContainer from '../../components/container';
import { CurrentLocale } from '../../App';
import { SharedProps } from '../../types/shared-props';
import { useParams } from 'react-router-dom';
import { GetNavbarCategoriesReponse, TransformToCategoryMenu } from '../../apis/response/GetNavbarCategoriesResponse';
import { GetPortalResponse, ToPortalLink } from '../../apis/response/GetPortalResponse';
import { ChineseTitleFormat } from '../../services/SpecialFormatService';


const useStyles = createStyles((theme) => ({
    home: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
    },

    container: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        zIndex: 5,
        backgroundColor: theme.colors.offWhite[0],
        opacity: 50,
        padding: '30px',
        margin: '0px',
    },

    title: {
        color: theme.colors.hkc[1],
        fontSize: theme.other.layout.title.fontSize,
        fontFamily: theme.other.titleFont,
        fontWeight: theme.other.layout.title.fontWeight,
        lineHeight: theme.other.layout.title.lineHeight
    },

    description: {
        color: theme.colors.offWhite[1],
        textAlign: 'left',
        fontSize: 16,
        padding: '0px 40px',
        fontFamily: ['PMingLiu', 'sans-serif']
    },

    slash: {
        height: theme.other.layout.slashHeight,
        backgroundColor: theme.colors.hkc[0],
        width: '80%',
        marginTop: 25,
    },

    content: {
        width: '100%',
        zIndex: 1
    },

    catContainer: {
        flexWrap: 'nowrap',
        alignItems: 'stretch',
        overflow: 'hidden'
    },
    smallCatContainer: {
        flexWrap: 'nowrap',
        alignItems: 'stretch',
        [theme.fn.largerThan('md')]: {
            display: 'none'
        }
    },
    category: {
        [theme.fn.largerThan('md')]: {
            width: 'calc((100vw - 40px)/12)',
        },
        [theme.fn.smallerThan('md')]: {
            width: '50%',
        },
        backgroundColor: theme.colors.hkc[0],
        whiteSpace: 'break-spaces',
        maxHeight: 'none',
        minWidth: 130,
        height: 'auto',
        '&:hover': {
            backgroundColor: theme.white,
            color: theme.colors.hkc[0],
            borderColor: theme.colors.hkc[0],

        },
        padding: 10
    },
    scrollBtn: {
        minWidth: 'unset !important',
        width: '70px !important',
    },
    catLabel: {
        whiteSpace: 'break-spaces',
        fontSize: 14,
    },
    catScroll: {
        display: 'flex',
        flex: 'row',
        justifyContent: 'space-between',
        [theme.fn.smallerThan('md')]: {
            display: 'none'
        },
        [theme.fn.largerThan('md')]: {
            display: 'flex'
        }
    },
    dropdownContainer: {
        borderRadius: 0,
        backgroundColor: theme.colors.hkc[0]
    },
    cover: {
        [theme.fn.smallerThan('md')]: {
            width: '100%',
        },
        [theme.fn.largerThan('md')]: {
            width: '70%',
        },
        height: 'auto',
        marginTop: 20
    },

    dividerContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        padding: '0px 40px',
        zIndex: 4
    },
    dividerBox: {
        flex: 1,
        flexGrow: 3,
        backgroundColor: theme.colors.hkc[1],
        height: theme.other.layout.slashHeight
    },
    dividerText: {
        padding: '25px 40px',
        color: theme.colors.hkc[0],
        fontWeight: 650,
        fontSize: theme.other.layout.sectionTitleFontSize,
        fontFamily: theme.other.titleFont
    },
    card: {
        width: '100%'
    },
    grid: {
        zIndex: 4,
        margin: '0px 20px',
    },
    desktopDesc: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'end',
        marginLeft: -30,
        marginTop: 120,
        padding: 20,
        bottom: 0,
        flexGrow: 1,
        backgroundColor:
            `${theme.colors.hkc[0]}EE`,
        zIndex: 4,
        [theme.fn.smallerThan('md')]: {
            display: 'none'
        }
    },
    mobileDesc: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'end',
        padding: 10,
        backgroundColor: theme.colors.hkc[0],
        zIndex: 1,
        [theme.fn.largerThan('md')]: {
            display: 'none'
        }
    },
    greySection: {
        // backgroundColor: 'rgb(200,200,200, .7)',
        backgroundColor: 'lightgrey',
        margin: '20px 0px',
        paddingBottom: 20,
        zIndex: 1,
    }
}));

interface SubCategoryPageProps {
    imgBinaryList?: ProductCardProp[];
    name?: TranslateField;
    desc?: TranslateField;
    cover?: string
    dept?: string
    cat?: string
    info?: TranslateField
}

const SubCategory = () => {
    const { classes } = useStyles()
    const theme = useMantineTheme()
    const init: SubCategoryPageProps & SharedProps = {}
    const [props, setProps] = useState(init)

    const subCat = props.imgBinaryList ?? []
    const [loading, setLoading] = useState(true)
    const { subCatId } = useParams()


    const fetchData = async () => {
        
        const dept = (await API.Category.GetDeptBySubCat(`${subCatId}`)).obj.dept_id
        const cat = (await API.Category.GetCatByDept(`${dept}`)).obj.category_id
        const catRes = (await API.Category.GetCat(cat)).obj
        const catInfo = TranslateCategory(catRes.items[0])

        const imageService = new ImageStorageService()
        const imgBinaryList = await imageService.GetSubCatCards(`${subCatId}`)
        const cover = await imageService.GetRandomCatCover(`${cat}`)

        const translate = new TranslationService()
        const info = await translate.TranslateSubCatName(`${subCatId}`)
        const name = await translate.TranslateDepartmentName(`${dept}`)
        const desc = await translate.TranslateDepartmentDesc(`${dept}`)


        const c: GetNavbarCategoriesReponse = (await API.Category.GetNavbarCategories()).obj

        const categories = TransformToCategoryMenu(c.items)
        const usefulRes: GetPortalResponse = (await API.Info.GetUsefulLinks()).obj
        const useful = usefulRes.items.map(x => ToPortalLink(x))
        const navTree: NavBarItem[] = [
            { title: catInfo, slug: `/Category/${cat}` },
            { title: name, slug: `/Department/${dept}` },
            { title: info, slug: `/SubCat/${subCatId}` },
        ]
        const newProps: SubCategoryPageProps & SharedProps = {
            imgBinaryList, cover, dept, cat, info, name, desc, categories, useful, navTree
        }
        setProps(newProps)
    }

    useEffect(() => {
        fetchData().then((res) => setLoading(false))
    }, [])

    return (
        <div style={{ backgroundImage: `url(${props.cover})`, width: '100%', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
            <Overlay
                color={theme.colors.offWhite[0]}
                opacity={.8}
                zIndex={0}
                style={{ height: '100%', position: 'fixed', width: '100%', mixBlendMode: 'lighten' }}
            />
            <DefaultContainer loading={loading}>
                <div className={classes.content}>
                    {
                        props.categories && props.useful ?
                            <CategoryNavbar data={props.categories} useful={props.useful} />
                            : <></>
                    }
                    <NavBar navTree={props.navTree ?? []} />
                    <div style={{ marginTop: 20, display: 'flex', flexDirection: 'row', padding: '0px 40px' }}>
                        {/* <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', marginLeft: '5%', marginBottom: 30, padding: 30, height: 300, minWidth: 300, backgroundColor: theme.colors.offWhite[0], zIndex: 5 }}> */}
                        <Container className={classes.container}>
                            <Group style={{ width: 250 }}>
                                <Title
                                    align='left'
                                    className={classes.title}
                                    dangerouslySetInnerHTML={{ __html: ChineseTitleFormat(GetTranslated(props.name, CurrentLocale)) }}
                                >
                                </Title>
                                <div className={classes.slash} />
                            </Group>
                        </Container>
                        {/* </div> */}
                        <div className={classes.desktopDesc}>
                            <Text
                                className={classes.description}
                            >
                                {GetTranslated(props.desc, CurrentLocale)}
                            </Text>
                            <div style={{ width: theme.other.layout.orangeSquare, height: theme.other.layout.orangeSquare, backgroundColor: theme.colors.hkc[1] }} />
                        </div>
                    </div>
                    <div className={classes.mobileDesc}>
                        <Text
                            className={classes.description}
                        >
                            {GetTranslated(props.desc, CurrentLocale)}
                        </Text>
                        <div style={{ width: 30, height: 30, backgroundColor: theme.colors.hkc[1] }} />
                    </div>
                    <div className={classes.greySection}>
                        <div style={{ marginTop: 20, display: 'flex', flexDirection: 'column' }}>
                            <div className={classes.dividerContainer}>
                                <div className={classes.dividerBox}></div>
                                <Text className={classes.dividerText}>
                                    {GetTranslated(props.info, CurrentLocale)}
                                </Text>
                                <div className={classes.dividerBox}></div>
                            </div>
                            <SimpleGrid className={classes.grid} cols={4} spacing={'lg'} breakpoints={[{ maxWidth: 'lg', cols: 3 }, { maxWidth: 'md', cols: 2 }, { maxWidth: 'sm', cols: 1 }]}>
                                {
                                    subCat.map((x: ProductCardProp) => {
                                        return <ProductCard key={x.slug} prop={x} className={classes.card} />
                                    })
                                }
                            </SimpleGrid>
                        </div>
                    </div>
                </div>
            </DefaultContainer>
        </div>
    )
}

export default SubCategory

